export const getRcsOnboaredBSPMutation = (builder) => ({
  getRcsOnboardedBSP: builder.mutation({
    query: ({ page = 1, limit = "", search = "" }) => {
      const token = JSON.parse(localStorage.getItem("TOKEN"))?.token || "";
      return {
        url: "/rcs_onboarded_bsp",
        method: "GET",
        params: {
          page,
          limit,
          search,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      };
    },
  }),
});
